<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="600">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-USER-TEAM' : 'EDIT-USER-TEAM') | translate }}</h3>
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="editForm" class="k-form">
    <div class="row">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'USER' | translate}} *
          </span>
          <kendo-combobox id="user" formControlName="user" class="w-100" [valuePrimitive]="false" [data]="users"
            [textField]="'name'" [valueField]="'id'" [itemDisabled]="userDisabled">
          </kendo-combobox>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="editForm.controls['user'].invalid && editForm.controls['user'].touched">
            {{'REQUIRED-USER' | translate}}
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'ROLE' | translate}} *
          </span>
          <kendo-combobox id="role" formControlName="role" class="w-100" [valuePrimitive]="false"
            [data]="teamRolesFiltered" [textField]="'name'" [valueField]="'id'" [filterable]="true"
            [virtual]="virtualSubRole" (filterChange)="filterTeamRoles($event)" (close)="searchTerm=''"
            [itemDisabled]="roleItemDisabled" (valueChange)="getSubRole($event?.teamType?.id)">
            <ng-template kendoComboBoxItemTemplate let-dataItem>
              <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
              </span>
            </ng-template>
          </kendo-combobox>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="editForm.controls['role'].invalid && editForm.controls['role'].touched">
            {{'REQUIRED-ROLE' | translate}}
          </div>
        </label>
      </div>
    </div>
    <div class="row" *ngIf="displaySubRoles">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'SUBROLE' | translate}} *
          </span>
          <kendo-combobox id="subRole" class="w-100" formControlName="subRole" [data]="subRoles"
            [textField]="'displayName'" [valueField]="'id'">
          </kendo-combobox>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="editForm.controls['subRole'].invalid && editForm.controls['subRole'].touched">
            {{'REQUIRED-SUBROLE' | translate}}
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'NOTIFICATION' | translate}} *
          </span>
          <kendo-combobox class="w-100" formControlName="notification" [data]="notifications" [textField]="'text'"
            [valueField]="'value'" [valuePrimitive]="true">
            <ng-template kendoComboBoxItemTemplate let-dataItem>
              <span innerHTML="{{ dataItem.value | translate }}">
              </span>
            </ng-template>
          </kendo-combobox>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="editForm.controls['notification'].invalid && editForm.controls['notification'].touched">
            {{'REQUIRED-NOTIFICATION' | translate}}
          </div>
        </label>
      </div>
    </div>
  </form>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button *ngIf="!isNew" class="k-button k-primary" [disabled]="isNew" (click)="confirmDeleteDialogOpened = true"
      style="position:absolute;left:15px">{{ 'DELETE' | translate }}
    </button>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
      (click)="onSave($event)">{{
      'SAVE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
<!-- confirm erase dialog -->
<kendo-dialog *ngIf="confirmDeleteDialogOpened" (close)="confirmDeleteDialogOpened = false" [minWidth]="400">
  <kendo-dialog-titlebar>
    <h3>{{'DELETE-TEAM-MEMBER' | translate}}</h3>
  </kendo-dialog-titlebar>
  <label>{{'CONFIRM-DELETE-TEAM-MEMBER' | translate:patientLabel}}</label>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="confirmDeleteDialogOpened = false">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="onDelete($event); confirmDeleteDialogOpened = false">
      {{'YES' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>